const fields = [
  {
    key: 'name',
    type: 'input',
    templateOptions: {
      label: 'name'
    }
  },
  {
    key: 'showTime',
    type: 'boolean',
    templateOptions: {
      label: 'showTime'
    }
  },
  {
    key: 'showShotClock',
    type: 'boolean',
    templateOptions: {
      label: 'showShotClock'
    }
  },
  {
    key: 'address',
    type: 'address',
    templateOptions: {
      label: 'address'
    }
  },
  {
    key: 'timezone',
    type: 'ntm-select',
    isString: true,
    optionsApi: 'timezones',
    templateOptions: {
      label: 'timezone'
    }
  }
]

export default fields
